module.exports = __webpack_public_path__ + "static/media/SJE091.9fd552f1.png";